import { HubCardType } from '@/types';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalInsightsStackParams } from '@/navigators/types';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import type { Alert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';

type InsightsRouteProp = RouteProp<
  SalesPortalInsightsStackParams,
  typeof SALES_PORTAL_ROUTES.Insights
>;

export interface InsightNavigation {
  close: () => void;
  openAlert: (alert: Alert) => void;
}

/** Open/close actions for the Lost Item item-detail drawer (route-param based). */
export const useInsightNavigation = (): InsightNavigation => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalInsightsStackParams>>();

  const openAlert = useCallback(
    (alert: Alert) => {
      if (alert.cardType === HubCardType.LostItem) {
        navigation.setParams({ lostItemAlertUUID: alert.alertUUID });
      }
    },
    [navigation],
  );

  const close = useCallback(() => {
    navigation.setParams({ lostItemAlertUUID: undefined });
  }, [navigation]);

  return { close, openAlert };
};

/** The open Lost Item drawer's alert uuid from the Insights route param, or null. */
export const useSelectedLostItemAlertUUID = (): string | null => {
  const route = useRoute<InsightsRouteProp>();
  return route.params?.lostItemAlertUUID ?? null;
};
